import type { ComponentChildren } from 'preact'
import { ProgressBar } from './progress-bar.tsx'
import styles from './progress-screen.module.css'

interface ProgressScreenProps {
  readonly title: ComponentChildren
  /** Short text above the bar, e.g. the current loading step. */
  readonly status: string
  /** Accessible name of the progress bar. */
  readonly label: string
  /** From 0 to 1, or `null` while unknown. */
  readonly value: number | null
}

/** A full-screen title with a progress bar, for boot and level loading. */
export function ProgressScreen({ title, status, label, value }: ProgressScreenProps) {
  return (
    <div class={styles.screen}>
      <h1 class={styles.title}>{title}</h1>
      <div class={styles.progress}>
        <span class={styles.label} aria-hidden="true">
          {status}
        </span>
        <ProgressBar value={value} label={label} />
      </div>
    </div>
  )
}
